import { ProjectHistoryOverlayViewModel } from "../ProjectHistoryOverlayView"
import { ProjectHistoryOverlayModel } from "./useProjectHistoryOverlayModel"

export function useProjectHistoryOverlayViewModel({
  historyModel,
  filterValues,
  onFilterChange,
  onClose
}: ProjectHistoryOverlayModel): ProjectHistoryOverlayViewModel {
  return { historyModel, filterValues, onFilterChange, onClose }
}
